import { gql } from "graphql-request";

const SERVER_DELETE_ACTION_PLAN = gql`
mutation SERVER_DeleteActionPlan($id: ID!) {
    deleteActionPlan(id: $id)
  }
`;
export default SERVER_DELETE_ACTION_PLAN;